<template>
<div>
    <b-field class="commonrules-grp"  :label="label">
        <b-input type="number" class="cstmb-input" v-model="internationalAirFareCap" @input="$emit('internationalAirFareCap',internationalAirFareCap)"/>
    </b-field></div>
</template>
<script>
export default{
    name : "InternationalAirFareCap",
    props:{ internationalAirFare : null},
    data(){
        return{
            internationalAirFareCap : null
        }
    },
    mounted() {
        this.internationalAirFareCap = this.internationalAirFare;
    },
    computed: {
        currencySymbol() {
            return this.$store.getters['travellersAndTrips/getUserCurrencyInfo'].symbol || "$"
        },
        label(){
            return 'Flight between countries  when the total cost is above ' + this.currencySymbol;
        }
    },
}
</script>